"use client";

import { ThemeProvider } from "#/providers/theme-provider";
import { Theme } from "#/types.ts/other";
import { NextIntlClientProvider, AbstractIntlMessages } from "next-intl";

export default function LayoutProvider({
  theme,
  locale,
  messages,
  children,
}: {
  theme: Theme;
  locale: string;
  messages: AbstractIntlMessages;
  children: React.ReactNode;
}) {
  return (
    <NextIntlClientProvider locale={locale} messages={messages} timeZone="America/New_York">
      <ThemeProvider value={theme}>{children}</ThemeProvider>
    </NextIntlClientProvider>
  );
}
